import React from "react";
import MaintenanceMode from "../../Admin/maintenance/MaintenanceMode";

const MaintenanceScreen = () => {
    return <MaintenanceMode />;
};

export default MaintenanceScreen;
